export default __webpack_public_path__ + "static/media/Gemi_Cerceve_Bg_2.2b8209ac.png";